<mat-card
    class="mb-25 tagus-card"
    [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <h5 class="mb-0">Browser Used & Traffic Reports</h5>
        <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
            <i class="ri-more-fill"></i>
        </button>
        <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
            <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                <i class="ri-add-circle-line"></i> Add
            </button>
            <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                <i class="ri-delete-bin-6-line"></i> Delete
            </button>
            <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                <i class="ri-restart-line"></i> Refresh
            </button>
        </mat-menu>
    </mat-card-header>
    <mat-card-content>
        <div class="reports-table table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th class="fw-semibold main-color">Channel</th>
                        <th class="fw-semibold gray-color">Sessions</th>
                        <th class="fw-semibold gray-color">Previous Period</th>
                        <th class="fw-semibold gray-color">Transactions</th>
                        <th class="fw-semibold gray-color">% Change</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="main-color fw-semibold">Organic Search</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Direct</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Referal</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td><span class="badge fw-semibold down">52.80% <i class="flaticon-down-filled-triangular-arrow"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Email</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Social</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-card-content>
</mat-card>